'use strict';

/**
 * Filters
 *
 * Custom Filters to Be Used Across Modules
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export time for ES6 usage
 *          7.11.0 #531 Remove time filter from custom filters
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 *
 * @copyright (c) 2015-2016 Webduct Systems Inc.
 */
var time = angular.module('wd.filters.dateTime', ['wd.helper.dateTime'])

    // Hours, Mins or Seconds to Human Readable Format
    .filter('time', function (wdDateTimeHelper) {

        /**
         * Convert time from one format to another
         *
         * @since 7.11.0
         *
         * @param {Number} input
         * @param {String} inputUnit can be one: 'y', 'M', 'w', 'd', 'h', 'm', 's', 'ms'
         * @param {Array|String} outputUnits e.g. ['y', 'M', 'w', 'd', 'h', 'm', 's', 'ms'], 'm'
         * @param {Boolean} round
         * @returns {String}
         */
        return function (input, inputUnit, outputUnits, round) {

            return wdDateTimeHelper.humanizeDuration(input, inputUnit, outputUnits, round);

        };

    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = time;
}
// EOF
